import { shouldRetryOnError } from './shouldRetryOnError';
import { withRetryStatus } from './withRetryStatus';
export const resilientSwrConfig = {
    errorRetryCount: 3,
    shouldRetryOnError,
    use: [withRetryStatus],
};
